import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { TEST_ENV } from '@/main/app.constants';
import { useHasPendingRequests } from '@seeqdev/api';
import { LoadingIndicator } from '@seeqdev/qomponents';

const SPINNER_HIDE_DELAY = process.env.NODE_ENV === TEST_ENV ? 50 : 1000;

/**
 * This component encapsulates the "loading indicator" spinner
 */
export const LoadingSpinner = () => {
  const hasPendingRequests = useHasPendingRequests();
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    if (hasPendingRequests) {
      setShowSpinner(true);
      return;
    }
    const hideTimeout = setTimeout(() => setShowSpinner(false), SPINNER_HIDE_DELAY);
    return () => clearTimeout(hideTimeout);
  }, [hasPendingRequests]);

  return (
    // Flex (rather than a plain block) so the inline-block spinner is centered in this box outright,
    // instead of being placed by its own `vertical-align: middle` against a line-box baseline.
    <div className={clsx('tw:flex tw:w-sq-30! tw:items-center tw:pl-sq-10', showSpinner ? 'visible' : 'hidden')}>
      <LoadingIndicator color="#fff" size="sm" testId="requestLoadingSpinner" />
    </div>
  );
};
